import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 6,
    paddingLeft: 8,
    paddingRight: 11,
  },
  text: {
    color: white,
  },
  icon: {
    color: white,
    marginLeft: 7,
    fontSize: 14,
  },
});
